module.exports = __webpack_public_path__ + "static/media/campaign-thumbnail-vishing.e2d15972.png";